import { render, staticRenderFns } from "./paginator.pug?vue&type=template&id=a6246d18&lang=pug&"
import script from "./paginator.js?vue&type=script&lang=js&"
export * from "./paginator.js?vue&type=script&lang=js&"
import style0 from "./paginator.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6246d18')) {
      api.createRecord('a6246d18', component.options)
    } else {
      api.reload('a6246d18', component.options)
    }
    module.hot.accept("./paginator.pug?vue&type=template&id=a6246d18&lang=pug&", function () {
      api.rerender('a6246d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paginator/index.vue"
export default component.exports